export default "__VITE_ASSET__CnPNTQXR__"